import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGE_TYPE } from '@/app/shared/constants/segmentConstants';
import { useAnalytics } from '@/app/shared/hooks/useAnalytics';
import useEffectOnce from '@/app/shared/hooks/useEffectOnce';
import { FinalCard, MuiButton, LoaderProgress } from '@/app/shared/ui';
import { useAppSelector } from '@/store/hooks';
import { TrustageSection } from '../uploadStips/components/TrustageSection';

const StipsFinalPage = () => {
  const [loaderDismissed, setLoaderDismissed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { trackPage } = useAnalytics({page_type: PAGE_TYPE.LIBERTY_MUTUAL_THANK_YOU});
  const { isUILoading, encounteredError, customErrorMessage } = useAppSelector((state) => state.ui);
  const contactId = useAppSelector((state) => state.auth.contactId) || '';
  const { failedFileNames } = useAppSelector((state) => state.upload);

  const showProgressLoader = isUILoading || !loaderDismissed;

  useEffect(() => {
    if (isUILoading) return;

    const timer = setTimeout(() => {
      setLoaderDismissed(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [isUILoading]);

  useEffectOnce(() => trackPage(PAGE_TYPE.ILENDING_HUB_UPLOAD));

  if (showProgressLoader) {
    return (
      <div className="final">
        <div className="final__loading">
          <p>Your files are uploading, please do not close the window or use the back button!</p>
          <LoaderProgress isComplete={!isUILoading} />
        </div>
      </div>
    );
  }

  const getFinalMessage = () => {
    if (customErrorMessage) return customErrorMessage;
    if (encounteredError) {
      return 'There was a problem sending your files. Re-send or check to make sure files are valid.';
    }
    return 'Your files have been received and your Loan Consultant has been notified.';
  };

  const handleBackToHelloRefiHub = () => {
    navigate(`/home${location.search}`);
  };

  return (
    <>
      <div className="home">
        <div className="home__card">
          <FinalCard title={encounteredError ? 'Oops!' : 'Thank you!'}>
            <div className="final-card__input">
              <div className="home__input--section">
                <div>{getFinalMessage()}</div>
              </div>
            </div>
            {failedFileNames && failedFileNames.length > 0 && (
              <div className="final-card__input--description">
                An error was encountered. <br />
                Please try resending the following files:
                <br />
                <br />
                {failedFileNames.map((file) => (
                  <div className="final-card__input--failedFileName" key={file}>
                    - {file}
                  </div>
                ))}
              </div>
            )}
          </FinalCard>
          <div className="final__button-container">
            <MuiButton
              variant="contained"
              color="primary"
              fullWidth
              type="submit"
              onClick={handleBackToHelloRefiHub}
            >
              Back to Hello Refi Hub
            </MuiButton>
          </div>
        </div>
      </div>

      {contactId && (
        <div className="document-form__container final-card-trustage">
          <TrustageSection contactId={contactId}/>
        </div>
      )}
    </>
  );
};

StipsFinalPage.displayName = 'StipsFinalPage';

export default StipsFinalPage;